// extracted by mini-css-extract-plugin
export var borderRadius = "_fi-4";
export var large = "_fi-3";
export var logoContainer = "_fi-0";
export var nameLogo = "_fi-2";
export var small = "_fi-1";